import { IconButton } from '@material-ui/core';
import { Refresh } from '@material-ui/icons';
import MaterialTable, { MTableToolbar } from 'material-table';
import React, { useEffect, useState } from 'react';
import { Button, Card, CardBody } from 'reactstrap';
import { Status } from '../../constants/status';
import {
  getFormattedDateString,
  getFormattedMoneyString,
  getFormattedStatus,
  getFormattedStatusFirstCapital,
} from '../../helpers/utils';
import AdvanceTable from '../advance-table/AdvanceTable';
import AdvanceTablePagination from '../advance-table/AdvanceTablePagination';
import AdvanceTableWrapper from '../advance-table/AdvanceTableWrapper';
import TooltipItem from './TooltipItem';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import StatusPill from './status-pill/StatusPill';

const isFunctionalComponent = (Component) => {
  return (
    typeof Component === 'function' && // can be various things
    !(
      (
        Component.prototype && // native arrows don't have prototypes
        Component.prototype.isReactComponent
      ) // special property
    )
  );
};

export const ProductTable = ({
  title,
  loadingProducts,
  products,
  additionalToolbarComponent,
  additionalHeaderComponent,
  allowAddNew,
  handleAddNew,
  handleOpenDetail,
  allowRefresh,
  handleRefresh,
}) => {
  const [pageSizeValue, setPageSizeValue] = useState(15);
  const [productsList, setProductsList] = useState(products);
  // const getFormattedDateString = (dateString) => {
  //   if (!dateString) return "";
  //   let splitted = dateString.split("-");
  //   return `${splitted[1]}/${splitted[2]}/${splitted[0]}`;
  // };

  useEffect(() => {
    setProductsList(products);
  }, [products]);

  const columns = [
    {
      Header: '',
      accessor: 'none',
      headerProps: { style: { whiteSpace: 'nowrap' } },
      Cell: (rowData) => {
        const { img_url, title } = rowData.row.original;
        return (
          <div style={{ height: 115, width: 90 }}>
            <img
              className='product-table-image'
              src={img_url}
              alt={title}
              style={{ height: '100%', width: '100%' }}
              loading={'lazy'}
            />
          </div>
        );
      },
    },
    {
      Header: 'ID',
      accessor: 'id',
      Cell: (rowData) => {
        const { id } = rowData.row.original;
        return <span style={{ fontSize: 14 }}>{`#${id}` || '-'}</span>;
      },
    },
    {
      Header: 'TITLE',
      accessor: 'title',
      sortType: (rowA, rowB, id, desc) => {
        const a = rowA?.original[id]?.toLowerCase() ?? '';
        const b = rowB?.original[id]?.toLowerCase() ?? '';
        return a.localeCompare(b);
      },
      Cell: (rowData) => {
        const { title, data } = rowData.row.original;
        return (
          <span style={{ fontSize: 14 }}>{title || data?.title || '-'}</span>
        );
      },
    },
    {
      Header: 'CREATED',
      accessor: 'consigned_on',
      // cellProps: { style: { whiteSpace: 'nowrap', } },
      Cell: (rowData) => {
        const { consigned_on } = rowData.row.original;
        return (
          <span style={{ fontSize: 14 }}>
            {getFormattedDateString(consigned_on)}
          </span>
        );
      },
    },
    {
      Header: 'PRICE',
      accessor: 'price',
      Cell: (rowData) => {
        const { priceString, price } = rowData.row.original;
        return (
          <span style={{ fontSize: 14 }}>
            {priceString
              ? getFormattedMoneyString(priceString)
              : getFormattedMoneyString(price)}
          </span>
        );
      },
    },
    {
      Header: 'STATUS',
      accessor: 'status_display_user',
      Cell: (rowData) => {
        const { status_display_user, status, status_color_code_user } =
          rowData.row.original;
        return (
          <StatusPill
            originalStatus={status}
            status={getFormattedStatus(status_display_user)}
            backgroundColor={
              status_display_user.toLowerCase() === 'failed'
                ? '#FF82A0'
                :  status_display_user.toLowerCase() === 'retired'
                ? '#E4D7F9'
                : status_color_code_user || '#000000'
            }
          />
        );
      },
    },
    {
      Header: '',
      accessor: 'consigned_by_user_id',
      Cell: (rowData) => {
        const { id } = rowData.row.original;
        return (
          <div
            style={{ cursor: 'pointer' }}
            className='glyph '
            onClick={(e) => {
              e.preventDefault();
              handleOpenDetail(rowData.row.id, id);
            }}
          >
            <ArrowForwardIcon />
          </div>
        );
      },
    },
  ];

  const ToolbarComponent = (props) => (
    <div className='table-custome-toolbar'>
      <div className='table-toolbar-select '>
        <div className='header'>
          <h2 className='' style={{ fontFamily: 'Brown', color: '#C98B76' }}>
            {title}
          </h2>
        </div>
      </div>
      <div className='common-table-toolbar-component relative'>
        {allowRefresh && (
          <>
            <TooltipItem
              item={{
                placement: 'bottom',
                text: 'Refresh',
              }}
              id={`tooltip_refresh`}
            />
            <IconButton
              aria-label='refresh table'
              component='span'
              onClick={handleRefresh}
              id={`tooltip_refresh`}
            >
              <Refresh />
            </IconButton>
          </>
        )}
        <MTableToolbar {...props} searchFieldStyle={{ fontFamily: 'Brown' }} />
      </div>
    </div>
  );

  const HeaderComponent = (props) => (
    <div className='header'>
      <h2 className=''>{title}</h2>
      {isFunctionalComponent(additionalHeaderComponent)
        ? additionalHeaderComponent(props)
        : null}
    </div>
  );

  return (
    <Card className='mb-4 no-shadow' style={{ backgroundColor: 'transparent' }}>
      {loadingProducts ? (
        <div
          className='loading-overlay'
          style={{ backgroundColor: 'transparent' }}
        >
          <div className='loading'></div>
        </div>
      ) : (
        <AdvanceTableWrapper
          columns={columns}
          data={productsList}
          pagination={productsList.length > 15}
          perPage={pageSizeValue}
          sortable={true}
        >
          <CardBody>
            <AdvanceTable
              table
              headerClassName='text-400 text-nowrap align-middle'
              rowClassName='align-middle white-space-nowrap'
              tableProps={{
                bordered: false,
                striped: false,
                loader: loadingProducts,
                className: 'mb-0 overflow-x-auto',
              }}
            />
          </CardBody>

          {productsList.length > 15 ? (
            <div className='my-5'>
              <AdvanceTablePagination
                table
                rowsPerPageSelection
                setPageSize={(value) => setPageSizeValue(value)}
                pageSize={pageSizeValue}
              />
            </div>
          ) : null}
        </AdvanceTableWrapper>
      )}
    </Card>
    // <MaterialTable
    //   title=''
    //   components={{
    //     Container: ({ children, ...other }) => (
    //       <Card className='mb-4 no-shadow common-product-list ' {...other}>
    //         <CardBody>
    //           {/* <HeaderComponent /> */}
    //           {children}
    //         </CardBody>
    //       </Card>
    //     ),
    //     OverlayLoading: () => (
    //       <div className=' loading-overlay'>
    //         <div className='loading'></div>
    //       </div>
    //     ),
    //     Toolbar: ToolbarComponent,
    //   }}
    //   isLoading={loadingProducts}
    //   columns={[
    //     {
    //       Header: '',
    //       accessor: '',
    //       headerProps: { style: { whiteSpace: 'nowrap' } },
    //       Cell: (rowData) => {
    //         const { img_url, title } = rowData.row.original;
    //         <img className='product-table-image' src={img_url} alt={title} />;
    //       },
    //     },
    //     {
    //       Header: 'ID',
    //       accessor: 'id',
    //     },
    //     {
    //       Header: 'Title',
    //       accessor: 'title',
    //       cellProps: {
    //         style: {
    //           width: 1000,
    //           maxWidth: 1000,
    //         },
    //       },
    //       headerProps: {
    //         style: {
    //           width: 1000,
    //           maxWidth: 1000,
    //         },
    //       },
    //     },
    //     {
    //       Header: 'Created',
    //       accessor: 'consigned_on',
    //       cellProps: { style: { whiteSpace: 'nowrap' } },
    //       Cell: (rowData) => {
    //         const { consigned_on } = rowData.row.original;
    //         return <span>{getFormattedDateString(consigned_on)}</span>;
    //       },
    //     },
    //     {
    //       Header: 'Price',
    //       accessor: 'price',
    //       Cell: (rowData) => {
    //         const { priceString } = rowData.row.original;
    //         return <span>{getFormattedMoneyString(priceString)}</span>;
    //       },
    //     },
    //     {
    //       Header: 'Status',
    //       accessor: 'status',
    //       Cell: (rowData) => {
    //         const { status } = rowData.row.original;
    //         return (
    //           <span>
    //             {getFormattedStatus(
    //               status === Status.draft_by_lender ? Status.draft : status
    //             )}
    //           </span>
    //         );
    //       },
    //     },
    //     {
    //       Header: '',
    //       accessor: 'id',
    //       sorting: false,
    //       Cell: (rowData) => {
    //         const { id } = rowData.row.original;
    //         console.log('rowData:::', rowData.row);
    //         return (
    //           <div
    //             className='glyph '
    //             onClick={(e) => {
    //               e.preventDefault();
    //               handleOpenDetail(id, id);
    //             }}
    //           >
    //             <div
    //               className={`glyph-icon simple-icon-arrow-right-circle text-muted`}
    //             />
    //           </div>
    //         );
    //       },
    //     },
    //   ]}
    //   data={products}
    //   options={{
    //     sorting: true,
    //     search: true,
    //     pageSize: 25,
    //     pageSizeOptions: [25, 50, 100],
    //     emptyRowsWhenPaging: false,
    //     headerStyle: { color: '#C98B76', fontFamily: 'Brown' },
    //     // toolbar: false,
    //   }}
    // />
  );
};
